import fileMethods from './view_case_details_file_methods';
import journalMethods from './view_case_details_journal_methods';
import workflowMethods from './view_case_details_workflow_methods';

export default {
  ...workflowMethods,
  ...journalMethods,
  ...fileMethods,
};
